import Table from "../../components/table/Table";
import {getDailyReport} from "../../api/getDailyReport";
import {ColProps, colTypeOptions, FetchProps, FilterProps, filterTypeOptions} from "../../components/table/tableTypes";
import {dateDaysAgo, formatDate} from "../../utils/friendlyDate";
import useAppContext from "../../hooks/useAppContext";
import {useEffect, useState} from "react";
import {MenuProps} from "antd";
import {exportToCsv} from "../../utils/exportToCsv";
import {MessageTemplateProps} from "../../types/MessageTemplateProps";

const Reports = () => {
    const { data: { templates } } = useAppContext();
    const [templatesOptions, setTemplatesOptions] = useState<MenuProps['items'] | null>(null);

    const fetch = async ({ filters, sortingBy, sortingDirection, limit, offset, selectedDomain, isCsvCall }: FetchProps) => {
        const response = await getDailyReport(selectedDomain, filters);
        if(isCsvCall) {
            exportToCsv(response.data.report, `Vuelve Revenue - ${selectedDomain} - ${formatDate(new Date())}`);
        } else {
            return selectedDomain ? response : [];
        }
    }

    useEffect(() => {
        templates.isLoaded && setTemplatesOptions(templates.data.map((template: MessageTemplateProps) => ({ key: template.id, label: template.title })))
    }, [templates.data, templates.isLoaded])

    const cols: ColProps[] = [
        { key: 'days', name: 'date', type: colTypeOptions.date, width: 130, isPinned: true },
        { key: 'totalCheckouts', name: 'checkouts', type: colTypeOptions.number, width: 100 },
        { key: 'totalOrders', name: 'orders', type: colTypeOptions.number },
        { key: 'totalSent', name: 'delivered', type: colTypeOptions.number, width: 100 },
        { key: 'totalFailed', name: 'failed', type: colTypeOptions.number },
        { key: 'totalClicks', name: 'clicked', type: colTypeOptions.number },
        { key: 'revenue', name: 'rev.', type: colTypeOptions.usd },
        { key: 'potentialRevenue', name: 'potential rev.', type: colTypeOptions.usd, width: 120 },
        { key: 'rpc', name: 'RPC', type: colTypeOptions.usd, width: 100 },
        { key: 'rps', name: 'RPS', type: colTypeOptions.usd, width: 100 },
    ];

    const filters: FilterProps[] = templatesOptions ? [
        { filterKey: 'days', name: 'date range', type: filterTypeOptions.date, min: dateDaysAgo(90), max: new Date(), from: dateDaysAgo(30), to: new Date() },
        { filterKey: 'templates', name: 'templates', type: filterTypeOptions.textToId, options: templatesOptions, allLabel: 'All Templates', selected: 0 }
    ] : [];

    return (
        <div className="reports-container">
            {templatesOptions ? <Table title="Revenue" fetch={fetch} cols={cols} filters={filters} showSearch={false} doneLoadingDependencies={templates.isLoaded} /> : null}
        </div>
    );
}

export default Reports;